<template>
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label>Planes:  </label>
    <b-form-select  v-model="plan" v-if="!loading" >
        <b-form-select-option v-for="elemento in planes" :key="elemento.idPlan" 
        :value="elemento.idPlan">{{ elemento.nombre }}</b-form-select-option>
    </b-form-select>
    <b-spinner small v-if="loading"></b-spinner>
</b-form-group>
</template>

<script>
export default {
    name: "Planes",
    props: { 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        planes: [],
        plan: null,
        loading: true,

    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
        getObtenerClinicasActivas() {
            this.$http
                .get(this.$api + "catalogos/listaEstados")
                .then((response) => {
                    this.estados = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                }).finally(() =>   
                    this.loading = false
                );
        },
    },
    mounted() {
        this.getObtenerClinicasActivas();
    }, 
}
</script>
